import FilledStar from '@mui/icons-material/Star'
import StarBorderSharpIcon from '@mui/icons-material/StarBorderSharp'
import Fab from '@mui/material/Fab'
import TableCell, { TableCellProps } from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { useQuery } from '@tanstack/react-query'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { TableLoader } from '@components/skeletonLoader/tableLoader'
import { CvsTable } from '@components/table/cvs-table'
import { colors } from '@global/constants/colors'
import { api } from 'api'
import * as css from './styles'
import { t } from '@lingui/core/macro'

async function fetchFavoriteDatasets() {
  const { data } = await api.get('/api/v1/account/template/favorites')
  return data
}

export const FavoriteDatasets = ({ keyField }) => {
  const loaderColumns = [
    {
      label: t`Template`,
      lookup: 'template',
      type: 'text',
      width: '40%',
    },
    {
      label: t`Updated`,
      lookup: 'updated',
      type: 'date',
      width: '20%',
    },
    {
      label: t`Folder`,
      lookup: 'folder',
      type: 'text',
      width: '40%',
    },
  ]
  const history = useHistory()
  const { data: favorites, isInitialLoading: isLoading } = useQuery({
    queryKey: ['favoriteDatasets'],
    queryFn: () => fetchFavoriteDatasets(),
    refetchOnWindowFocus: false,
  })

  function handleRowClick(row) {
    history.push(`/codes/create/${row.id}`)
  }

  return (
    <>
      <Typography
        variant="h4"
        gutterBottom
        style={{ padding: 24, margin: 0, display: 'flex', alignItems: 'center' }}
      >
        <FilledStar style={{ marginRight: 10, color: 'rgb(245, 171, 53)' }} />{' '}
        {t`Favorite templates`}
      </Typography>
      {!isLoading ? (
        <CvsTable
          keyField="id"
          orderBy="last_created"
          columns={[
            { label: t`Template Name`, width: '40%', lookup: 'name' },
            { label: t`Updated`, width: '20%', lookup: 'updated_at' },
            { label: t`Folder`, width: '40%', lookup: 'folder.name' },
          ]}
          rows={favorites}
          noAdd={true}
          noPagination={true}
          overrideRootStyles={css.overrideRootStyles}
          overrideTableWrapperStyles={css.overrideTableWrapperStyles}
          emptyStateMessage={{
            icon: (
              <Fab
                style={{
                  height: '65px',
                  width: '65px',
                  color: colors.gray.light,
                  cursor: 'auto',
                }}
                disabled
              >
                <StarBorderSharpIcon style={{ fontSize: '34px', color: colors.blue.smokey }} />
              </Fab>
            ),
            title: t`No Favorite Templates`,
            description: t`Favorites are a fast and easy way to quickly navigate to your most used templates.`,
          }}
        >
          {({ row, index }) => {
            const altRow = index % 2 === 0
            const cellProps: TableCellProps = {
              component: 'th',
              scope: 'row',
              padding: 'normal',
              style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
            }
            return (
              <TableRow
                hover
                className={altRow ? '-is-alt-row' : ''}
                onClick={() => {
                  handleRowClick(row)
                }}
                tabIndex={-1}
                key={row[keyField]}
                css={css.tableRowStyle}
              >
                <TableCell {...cellProps}>{row.name}</TableCell>
                <TableCell {...cellProps}>{moment(row.updated_at).format('MM/DD/YY')}</TableCell>
                <TableCell {...cellProps}>{row.folder ? row.folder.name : ''}</TableCell>
              </TableRow>
            )
          }}
        </CvsTable>
      ) : (
        <TableLoader
          columns={loaderColumns}
          overrideContainerStyle={css.overrideRootStyles}
          overrideTableStyle={css.overrideTableLoader}
        />
      )}
    </>
  )
}
